import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { stripSlash } from './lib/paths'
import { CmsProvider } from './cms/CmsProvider'
import Layout from './components/Layout'
import AdminContributorForm from './admin/AdminContributorForm'
import AdminContributors from './admin/AdminContributors'
import AdminDashboard from './admin/AdminDashboard'
import AdminHealth from './admin/AdminHealth'
import AdminTeam from './admin/AdminTeam'
import AdminAccount from './admin/AdminAccount'
import AdminNewsletterPage from './admin/AdminNewsletterPage'
import AdminLogs from './admin/AdminLogs'
import AdminOnly from './admin/AdminOnly'
import AdminLegacyPostRedirect from './admin/AdminLegacyPostRedirect'
import AdminLogin from './admin/AdminLogin'
import AdminPostForm from './admin/AdminPostForm'
import AdminPosts from './admin/AdminPosts'
import AdminShell from './admin/AdminShell'
import AdminStats from './admin/AdminStats'
import Author from './pages/Author'
import About from './pages/About'
import Archive from './pages/Archive'
import Article from './pages/Article'
import Closet from './pages/Closet'
import Contact from './pages/Contact'
import Contributors from './pages/Contributors'
import Home from './pages/Home'
import Legal from './pages/Legal'
import Newsletter from './pages/Newsletter'
import NotFound from './pages/NotFound'
import Press from './pages/Press'

export function AppRoutes() {
  const location = useLocation()
  const pathname = stripSlash(location.pathname)
  const routeLocation = pathname === location.pathname ? location : { ...location, pathname }

  return (
        <Routes location={routeLocation}>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminShell />}>
            <Route index element={<AdminDashboard />} />
            <Route path="posts" element={<Navigate to="/admin/trends" replace />} />
            <Route path="posts/new" element={<Navigate to="/admin/trends/new" replace />} />
            <Route path="posts/:id" element={<AdminLegacyPostRedirect />} />
            <Route path="contributors" element={<AdminOnly><AdminContributors /></AdminOnly>} />
            <Route path="contributors/new" element={<AdminOnly><AdminContributorForm /></AdminOnly>} />
            <Route path="contributors/:id" element={<AdminOnly><AdminContributorForm /></AdminOnly>} />
            <Route path="stats" element={<AdminOnly><AdminStats /></AdminOnly>} />
            <Route path="health" element={<AdminOnly><AdminHealth /></AdminOnly>} />
            <Route path="newsletter" element={<AdminOnly><AdminNewsletterPage /></AdminOnly>} />
            <Route path="team" element={<AdminOnly><AdminTeam /></AdminOnly>} />
            <Route path="logs" element={<AdminOnly><AdminLogs /></AdminOnly>} />
            <Route path="account" element={<AdminAccount />} />
            <Route path=":type" element={<AdminPosts />} />
            <Route path=":type/new" element={<AdminPostForm />} />
            <Route path=":type/:id" element={<AdminPostForm />} />
          </Route>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/look-books" element={<Archive />} />
            <Route path="/trends" element={<Archive />} />
            <Route path="/2dos" element={<Archive />} />
            <Route path="/travel" element={<Archive />} />
            <Route path="/food" element={<Archive />} />
            <Route path="/beauty" element={<Archive />} />
            <Route path="/wellness" element={<Archive />} />
            <Route path="/stories" element={<Archive />} />
            <Route path="/stories/:slug" element={<Article />} />
            <Route path="/author/:slug" element={<Author />} />
            <Route path="/closet" element={<Closet />} />
            <Route path="/about" element={<About />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contributors" element={<Contributors />} />
            <Route path="/press" element={<Press />} />
            <Route path="/terms" element={<Legal />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
  )
}

export default function App() {
  return (
    <CmsProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </CmsProvider>
  )
}
